import type {
  GetCustomerAppointmentCancelPreflight,
  GetCustomerAppointmentNotificationLog,
  PutCustomerAppointment,
  PutCustomerAppointmentsAttendance,
} from "@/server-types";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";
import { get, put } from "../request-helpers";

/**
 * PUT /customer-appointments/attendance
 */
export const useUpdateCustomerAppointmentsAttendance = () => {
  return useCustomMutation({
    mutationFn: ({
      body,
    }: {
      body: PutCustomerAppointmentsAttendance["body"];
    }) =>
      put<PutCustomerAppointmentsAttendance>(
        `/customer-appointment/attendance`,
        body,
      ),
  });
};

/**
 * PUT /customer-appointments/:customerAppointmentId
 */
export const useUpdateCustomerAppointment = () => {
  return useCustomMutation({
    mutationFn: ({
      body,
      customerAppointmentId,
    }: {
      body: PutCustomerAppointment["body"];
      customerAppointmentId: number;
    }) =>
      put<PutCustomerAppointment>(
        `/customer-appointment/${customerAppointmentId}`,
        body,
      ),
  });
};

/**
 * GET /customer-appointment/:customerAppointmentId/notification-log
 */
export function useGetCustomerAppointmentNotificationLog({
  customerAppointmentId,
  enabled = true,
}: {
  customerAppointmentId?: number;
  enabled?: boolean;
}) {
  return useCustomQuery({
    queryKey: ["customerAppointmentNotificationLog", customerAppointmentId],
    queryFn: () =>
      get<GetCustomerAppointmentNotificationLog>(
        `/customer-appointment/${customerAppointmentId!}/notification-log`,
      ),
    enabled: customerAppointmentId != null && enabled,
  });
}

/**
 * GET /customer-appointment/:customerAppointmentId/cancel-preflight
 */
export function useGetCustomerAppointmentCancelPreflight({
  customerAppointmentId,
  enabled = true,
}: {
  customerAppointmentId?: number;
  enabled?: boolean;
}) {
  return useCustomQuery({
    queryKey: ["customerAppointmentCancelPreflight", customerAppointmentId],
    queryFn: () =>
      get<GetCustomerAppointmentCancelPreflight>(
        `/customer-appointment/${customerAppointmentId!}/cancel-preflight`,
      ),
    enabled: customerAppointmentId != null && enabled,
  });
}
